(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9413,2597,5901],{

/***/ 59006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ BuildHighPerformance; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TabsLayout/index.ts + 1 modules
var TabsLayout = __webpack_require__(82274);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/useTabs/index.ts + 1 modules
var useTabs = __webpack_require__(53834);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-1.webp
var BuildHighPerformance_1 = __webpack_require__(73531);
var BuildHighPerformance_1_default = /*#__PURE__*/__webpack_require__.n(BuildHighPerformance_1);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-1@2x.png
var BuildHighPerformance_1_2x = __webpack_require__(10944);
var BuildHighPerformance_1_2x_default = /*#__PURE__*/__webpack_require__.n(BuildHighPerformance_1_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-1@2x.webp
var assets_BuildHighPerformance_1_2x = __webpack_require__(74466);
var assets_BuildHighPerformance_1_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BuildHighPerformance_1_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-2.webp
var BuildHighPerformance_2 = __webpack_require__(28356);
var BuildHighPerformance_2_default = /*#__PURE__*/__webpack_require__.n(BuildHighPerformance_2);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-2@2x.png
var BuildHighPerformance_2_2x = __webpack_require__(31698);
var BuildHighPerformance_2_2x_default = /*#__PURE__*/__webpack_require__.n(BuildHighPerformance_2_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-2@2x.webp
var assets_BuildHighPerformance_2_2x = __webpack_require__(84343);
var assets_BuildHighPerformance_2_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BuildHighPerformance_2_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-3.webp
var BuildHighPerformance_3 = __webpack_require__(2156);
var BuildHighPerformance_3_default = /*#__PURE__*/__webpack_require__.n(BuildHighPerformance_3);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-3@2x.png
var BuildHighPerformance_3_2x = __webpack_require__(15282);
var BuildHighPerformance_3_2x_default = /*#__PURE__*/__webpack_require__.n(BuildHighPerformance_3_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/assets/BuildHighPerformance-3@2x.webp
var assets_BuildHighPerformance_3_2x = __webpack_require__(38794);
var assets_BuildHighPerformance_3_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BuildHighPerformance_3_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/BuildHighPerformance.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var copy = {
  heading: "Build high-performance teams",
  description: "By making analytics easy to access, you\u2019ll enable your team to become truly data-driven."
};
var tabs = [{
  key: "DEMOCRATIZE_DATA_ACCESS_SLIDE_KEY",
  title: "Democratize data access",
  description: "Teams move faster when everyone has access to SQL. Enable data warehousing with the flip of a switch.",
  image: {
    png2x: (BuildHighPerformance_1_2x_default()),
    webp: (BuildHighPerformance_1_default()),
    webp2x: (assets_BuildHighPerformance_1_2x_default()),
    width: 620,
    height: 420
  }
}, {
  key: "ATTRIBUTE_FEATURE_EXPERIMENTS_SLIDE_KEY",
  title: "Attribute feature experiments",
  description: "Study how new features affect your product\u2019s KPI, by enabling a product analytics tool.",
  image: {
    png2x: (BuildHighPerformance_2_2x_default()),
    webp: (BuildHighPerformance_2_default()),
    webp2x: (assets_BuildHighPerformance_2_2x_default()),
    width: 589,
    height: 389
  }
}, {
  key: "MEASURE_IMPROVE_KPI_SLIDE_KEY",
  title: "Measure & improve KPIs",
  description: "By making analytics easy to access, your team will see making decisions using data as the norm.",
  image: {
    png2x: (BuildHighPerformance_3_2x_default()),
    webp: (BuildHighPerformance_3_default()),
    webp2x: (assets_BuildHighPerformance_3_2x_default()),
    width: 589,
    height: 389
  }
}];
var warehousesLink = {
  text: "Explore our Warehouses Product",
  url: "/product/warehouses/"
};

var QueryDataSection = function QueryDataSection() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useTabs = (0,useTabs/* default */.Z)(0, tabs.length, "query-data-section"),
      getTrackProps = _useTabs.getTrackProps,
      getControlProps = _useTabs.getControlProps,
      getPanelProps = _useTabs.getPanelProps,
      activeTabKey = _useTabs.activeTabKey;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabsLayout/* default */.ZP, {
        reverse: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Controls */.ZX, _objectSpread(_objectSpread({}, getTrackProps()), {}, {
          children: tabs.map(function (tab, index) {
            return (0,emotion_react_browser_esm/* createElement */.az)(TabsLayout/* Control */.oT, _objectSpread(_objectSpread({}, getControlProps(index)), {}, {
              key: tab.key
            }), tab.title);
          })
        })), tabs.map(function (tab, index) {
          return (0,emotion_react_browser_esm/* createElement */.az)(TabsLayout/* Content */.VY, _objectSpread(_objectSpread({}, getPanelProps(index)), {}, {
            active: index === activeTabKey,
            key: tab.key
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Copy */.CK, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                variant: "h2",
                children: tab.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                variant: "pLarge",
                children: tab.description
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
                href: (0,getAbsoluteUrl/* default */.Z)(warehousesLink.url, pageConfig),
                children: warehousesLink.text
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Media */.pU, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                type: "image/webp",
                srcSet: "".concat(tab.image.webp, ", ").concat(tab.image.webp2x, " 2x")
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                alt: tab.title,
                width: tab.image.width,
                height: tab.image.height,
                src: tab.image.png2x,
                loading: "lazy"
              })]
            })
          }));
        })]
      })
    })]
  });
};

/* harmony default export */ var BuildHighPerformance = (QueryDataSection);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/BuildHighPerformance/index.ts


/***/ }),

/***/ 63009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useMaskOnScroll_useMaskOnScroll; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(21687);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/scroll/use-element-scroll.mjs
var use_element_scroll = __webpack_require__(66057);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs + 1 modules
var use_transform = __webpack_require__(29682);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-template.mjs
var use_motion_template = __webpack_require__(85770);
// EXTERNAL MODULE: ../../libs/utils/useResizeObserver/index.ts + 1 modules
var useResizeObserver = __webpack_require__(73889);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/useMaskOnScroll.ts



var _templateObject;




/**
 * A hook to create a mask on scroll
 * @param props.wrapper - A ref to the element to observe
 * @param props.axis - The axis to apply the mask
 * @param props.offset - The offset to apply to the mask
 * @returns A string to use as a mask
 */

var useMaskOnScroll = function useMaskOnScroll(_ref) {
  var wrapper = _ref.wrapper,
      _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? "horizontal" : _ref$axis,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? "8%" : _ref$offset;
  var clientValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var scrollValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var sizeValue = (0,use_motion_value/* useMotionValue */.c)(0);

  var _useElementScroll = (0,use_element_scroll/* useElementScroll */.B)(wrapper),
      scrollYProgress = _useElementScroll.scrollYProgress,
      scrollXProgress = _useElementScroll.scrollXProgress;

  var isVertical = axis === "vertical";
  var scrollProgress = isVertical ? scrollYProgress : scrollXProgress;
  var values = /^([-.\d]+(?:\.\d+)?)(.*)$/.exec(offset);
  var degs = isVertical ? (0,use_motion_value/* useMotionValue */.c)(180) : (0,use_motion_value/* useMotionValue */.c)(90);
  var unit = (0,use_motion_value/* useMotionValue */.c)(values && values[2]);
  var offsetValue = values ? Number(values[1]) : 0;

  if (isVertical) {
    var _wrapper$current;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.getBoundingClientRect().height));
  } else {
    var _wrapper$current2;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current2 = wrapper.current) === null || _wrapper$current2 === void 0 ? void 0 : _wrapper$current2.getBoundingClientRect().width));
  }

  (0,react.useEffect)(function () {
    if (unit.get() === "%") return;

    var handleResize = function handleResize() {
      if (isVertical) {
        var _wrapper$current3;

        sizeValue.set(Number((_wrapper$current3 = wrapper.current) === null || _wrapper$current3 === void 0 ? void 0 : _wrapper$current3.getBoundingClientRect().height));
      } else {
        var _wrapper$current4;

        sizeValue.set(Number((_wrapper$current4 = wrapper.current) === null || _wrapper$current4 === void 0 ? void 0 : _wrapper$current4.getBoundingClientRect().width));
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [isVertical, unit]);
  var maskStartSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 3),
        clientValue = _ref3[0],
        scrollValue = _ref3[1],
        scrollProgressValue = _ref3[2];

    return clientValue === scrollValue ? 0 : Math.min(offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskEndSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref4) {
    var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 3),
        clientValue = _ref5[0],
        scrollValue = _ref5[1],
        scrollProgressValue = _ref5[2];

    return clientValue === scrollValue ? sizeValue.get() : Math.max(sizeValue.get() - offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskImage = (0,use_motion_template/* useMotionTemplate */.Y)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["linear-gradient(", "deg, rgba(0,0,0,0) 0", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,0) ", "", ")"])), degs, unit, maskStartSize, unit, maskEndSize, unit, sizeValue, unit);
  var setValue = (0,react.useCallback)(function () {
    var _ref6, _wrapper$current5, _wrapper$current6, _ref7, _wrapper$current7, _wrapper$current8;

    clientValue.set((_ref6 = isVertical ? (_wrapper$current5 = wrapper.current) === null || _wrapper$current5 === void 0 ? void 0 : _wrapper$current5.clientHeight : (_wrapper$current6 = wrapper.current) === null || _wrapper$current6 === void 0 ? void 0 : _wrapper$current6.clientWidth) !== null && _ref6 !== void 0 ? _ref6 : 0);
    scrollValue.set((_ref7 = isVertical ? (_wrapper$current7 = wrapper.current) === null || _wrapper$current7 === void 0 ? void 0 : _wrapper$current7.scrollHeight : (_wrapper$current8 = wrapper.current) === null || _wrapper$current8 === void 0 ? void 0 : _wrapper$current8.scrollWidth) !== null && _ref7 !== void 0 ? _ref7 : 0);
  }, [clientValue, wrapper, scrollValue]);
  (0,useResizeObserver/* default */.Z)(wrapper, setValue);
  (0,react.useEffect)(function () {
    return setValue();
  }, [setValue]);
  return maskImage;
};

/* harmony default export */ var useMaskOnScroll_useMaskOnScroll = (useMaskOnScroll);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/index.ts


/***/ }),

/***/ 73889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useResizeObserver_useResizeObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(97209);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/useResizeObserver.ts


/**
 * The useResizeObserver reports changes to the dimensions of an element's content or border box
 * @param ref - A ref to the element to observe
 * @param fn - A callback function called when size of the observed element change
 */

var useResizeObserver = function useResizeObserver(ref, fn) {
  (0,react.useEffect)(function () {
    var resizeObserver = new ResizeObserver_es/* default */.Z(function () {
      fn();
    });

    if (ref !== null && ref !== void 0 && ref.current) {
      resizeObserver.observe(ref.current);
    }

    return function () {
      resizeObserver.disconnect();
    };
  }, [fn, ref]);
};

/* harmony default export */ var useResizeObserver_useResizeObserver = (useResizeObserver);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/index.ts


/***/ }),

/***/ 32523:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A hook to scroll to an element
 *
 * @param container - A ref to the container to scroll
 * @returns A function to scroll to an element
 */
var useScrollTo = function useScrollTo(container) {
  return function (element) {
    var el = element.current;
    var parent = container.current;

    if (parent && el) {
      parent.scrollTo({
        left: el.offsetLeft - (parent.offsetWidth - el.offsetWidth) / 2,
        behavior: "smooth"
      });
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollTo);

/***/ }),

/***/ 10944:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-1@2x-b796857d0144dd45f0ea009a7b56d982.png";

/***/ }),

/***/ 31698:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-2@2x-b1ebc31c2243bb3bd91c9314115aff3c.png";

/***/ }),

/***/ 15282:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-3@2x-55a14bb4405239816448b633739ae558.png";

/***/ }),

/***/ 73531:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-1-8e3df2ceb12f3366a8f804566c3c1c5f.webp";

/***/ }),

/***/ 74466:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-1@2x-164c5452224ad32e34a9a3542b2b900c.webp";

/***/ }),

/***/ 28356:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-2-6b4cf4e8c560f46acf91e30d8a531d1c.webp";

/***/ }),

/***/ 84343:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-2@2x-ad47490a3936450924232faf5a149485.webp";

/***/ }),

/***/ 2156:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-3-d939c997c975494414b89d4e6d4153b5.webp";

/***/ }),

/***/ 38794:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildHighPerformance-3@2x-428aad3d4da04c896a01db0e660543bd.webp";

/***/ }),

/***/ 28957:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LayoutGroup; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(3422);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/DeprecatedLayoutGroupContext.mjs


/**
 * @deprecated
 */
var DeprecatedLayoutGroupContext = (0,react.createContext)(null);



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-force-update.mjs
var use_force_update = __webpack_require__(85886);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/group.mjs
var notify = function (node) {
    return !node.isLayoutDirty && node.willUpdate(false);
};
function nodeGroup() {
    var nodes = new Set();
    var subscriptions = new WeakMap();
    var dirtyAll = function () { return nodes.forEach(notify); };
    return {
        add: function (node) {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: function (node) {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs








var shouldInheritGroup = function (inherit) { return inherit === true; };
var shouldInheritId = function (inherit) {
    return shouldInheritGroup(inherit === true) || inherit === "id";
};
var LayoutGroup = function (_a) {
    var _b, _c;
    var children = _a.children, id = _a.id, inheritId = _a.inheritId, _d = _a.inherit, inherit = _d === void 0 ? true : _d;
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    var layoutGroupContext = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    var deprecatedLayoutGroupContext = (0,react.useContext)(DeprecatedLayoutGroupContext);
    var _e = (0,tslib_es6/* __read */.CR)((0,use_force_update/* useForceUpdate */.N)(), 2), forceRender = _e[0], key = _e[1];
    var context = (0,react.useRef)(null);
    var upstreamId = (_b = layoutGroupContext.id) !== null && _b !== void 0 ? _b : deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id: id,
            group: shouldInheritGroup(inherit)
                ? (_c = layoutGroupContext === null || layoutGroupContext === void 0 ? void 0 : layoutGroupContext.group) !== null && _c !== void 0 ? _c : nodeGroup()
                : nodeGroup(),
        };
    }
    var memoizedContext = (0,react.useMemo)(function () { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context.current), { forceRender: forceRender })); }, [key]);
    return (react.createElement(LayoutGroupContext/* LayoutGroupContext.Provider */.p.Provider, { value: memoizedContext }, children));
};




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

}]);